module.exports = __webpack_public_path__ + "static/media/Vector.782b5eb4.svg";